export const SCAFFOLDER_PAGE_HEADER_TITLE = 'Create...';
export const SCAFFOLDER_PAGE_HEADER_SUBTITLE =
  'Create a new project or onboard by using one of the available templates';

export const SCAFFOLDER_PAGE_HEADER_OPTIONS = {
  title: SCAFFOLDER_PAGE_HEADER_TITLE,
  subtitle: SCAFFOLDER_PAGE_HEADER_SUBTITLE,
};
